import { useState, useEffect } from 'react'
import api from '../components/api'
import Table from 'react-bootstrap/Table'
import { nomeMes } from '../components/functions'


const Residuos_DadosGeracaoConsolidado = (props) => {

    const residuo_id = props.formulario_id
    
    const [grupoResiduo_id, setGrupoResiduo_id] = useState()
    const [resultadoGrupoResiduo, setResultadoGrupoResiduo] = useState()
    const [resultado, setResultado] = useState()

    const carregaGrupos = () => {

        api.get('grupoResid').then((result) => {

            setResultadoGrupoResiduo(result.data.map((rs) =>

                rs.grupoResiduo_id == 2 || rs.grupoResiduo_id == 3 || rs.grupoResiduo_id == 4 || rs.grupoResiduo_id == 6 ?

                <option value={rs.grupoResiduo_id}>{rs.grupoResiduo_descri}</option>

                :

                null
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        carregaGrupos()

    }, [])



    const carregaRelatorio = () => {

        setResultado()

        if (residuo_id) {


            switch (grupoResiduo_id) {

                case '2':

                    api.get(`residuosMontaTabelaGrupoAE/${residuo_id}`).then((result) => {

                        //console.log(result.data)

                        setResultado(result.data.map((rs) =>
                        
                            <tr style={{ fontSize: '11px'}}>
                                <td style={{ textAlign: 'center'}}>
                                    {rs.ano}
                                </td>
                                <td style={{ textAlign: 'center'}}>
                                    {nomeMes(rs.mes)}
                                </td>
                                
                                <td>
                                    {rs.tipoTratamentoA3_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosA3 ? rs.totalResiduosA3.toLocaleString('pt-BR') : ''}
                                </td>

                                <td>
                                    {rs.tipoTratamentoA4_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosA4 ? rs.totalResiduosA4.toLocaleString('pt-BR') : ''}
                                </td>
                                
                                <td>
                                    {rs.tipoTratamentoA5_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosA5 ? rs.totalResiduosA5.toLocaleString('pt-BR') : ''}
                                </td>

                                <td>
                                    {rs.tipoTratamentoA145_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosA145 ? rs.totalResiduosA145.toLocaleString('pt-BR') : ''}

                                </td>

                                <td>
                                    {rs.tipoTratamentoA145E_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosA145E}

                                </td>

                                


                                <td>
                                    {rs.tipoTratamentoA145EPerfuro_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosA145EPerfuro ? rs.totalResiduosA145EPerfuro.toLocaleString('pt-BR') : ''}

                                </td>
                                
                            </tr>
                    
                        ))

                    }).catch((err) => {

                        console.log(err.response)

                    })

                break

                case '3':


                    api.get(`residuosMontaTabelaGrupoB/${residuo_id}`).then((result) => {

                        //console.log(result.data)

                        setResultado(result.data.map((rs) =>
                        
                            <tr style={{ fontSize: '11px'}}>
                                <td style={{ textAlign: 'center'}}>
                                    {rs.ano}
                                </td>
                                <td style={{ textAlign: 'center'}}>
                                    {nomeMes(rs.mes)}
                                </td>

                                <td>
                                    {rs.tipoTratamentoFarm_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosFarm ? rs.totalResiduosFarm.toLocaleString('pt-BR') : ''}

                                </td>

                                <td>
                                    {rs.tipoTratamentoMetal_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosMetal ? rs.totalResiduosMetal.toLocaleString('pt-BR') : ''}

                                </td>

                                <td>
                                    {rs.tipoTratamentoQP_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosQP ? rs.totalResiduosQP.toLocaleString('pt-BR') : ''}

                                </td>

                                <td>
                                    {rs.tipoTratamentoQPF_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosQPF ? rs.totalResiduosQPF.toLocaleString('pt-BR') : ''}

                                </td>
                                
                              
                                
                            </tr>
                    
                        ))

                    }).catch((err) => {

                        console.log(err.response)

                    })

                break

                case '4':


                    api.get(`residuosMontaTabelaGrupoD/${residuo_id}`).then((result) => {

                        //console.log(result.data)

                        setResultado(result.data.map((rs) =>
                        
                            <tr style={{ fontSize: '11px'}}>
                                <td style={{ textAlign: 'center'}}>
                                    {rs.ano}
                                </td>
                                <td style={{ textAlign: 'center'}}>
                                    {nomeMes(rs.mes)}
                                </td>

                                <td>
                                    {rs.tipoTratamentoSeco_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosSeco ? rs.totalResiduosSeco.toLocaleString('pt-BR') : ''}

                                </td>

                                <td>
                                    {rs.tipoTratamentoUmido_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosUmido ? rs.totalResiduosUmido.toLocaleString('pt-BR') : ''}

                                </td>

                                <td>
                                    {rs.tipoTratamentoRejeito_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosRejeito ? rs.totalResiduosRejeito.toLocaleString('pt-BR') : ''}

                                </td>

                              
                                
                            </tr>
                    
                        ))

                    }).catch((err) => {

                        console.log(err.response)

                    })

                break

                case '6':


                    api.get(`residuosMontaTabelaGrupoEspecifico/${residuo_id}`).then((result) => {

                        //console.log(result.data)

                        setResultado(result.data.map((rs) =>
                        
                            <tr style={{ fontSize: '11px'}}>
                                <td style={{ textAlign: 'center'}}>
                                    {rs.ano}
                                </td>
                                <td style={{ textAlign: 'center'}}>
                                    {nomeMes(rs.mes)}
                                </td>

                                <td>
                                    {rs.tipoTratamentoEletro_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosEletro ? rs.totalResiduosEletro.toLocaleString('pt-BR') : ''}

                                </td>

                                <td>
                                    {rs.tipoTratamentoExplante_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosExplante ? rs.totalResiduosExplante.toLocaleString('pt-BR') : ''}

                                </td>

                                <td>
                                    {rs.tipoTratamentoLampada_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosLampada ? rs.totalResiduosLampada.toLocaleString('pt-BR') : ''}

                                </td>


                                <td>
                                    {rs.tipoTratamentoOleo_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosOleo ? rs.totalResiduosOleo.toLocaleString('pt-BR') : ''}

                                </td>


                                <td>
                                    {rs.tipoTratamentoRaioX_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosRaioX ? rs.totalResiduosRaioX.toLocaleString('pt-BR') : ''}

                                </td>


                                <td>
                                    {rs.tipoTratamentoPilha_descri}
                                </td>
                                <td style={{ textAlign: 'right'}}>
                                    {rs.totalResiduosPilha ? rs.totalResiduosPilha.toLocaleString('pt-BR') : ''}

                                </td>

                              
                                
                            </tr>
                    
                        ))

                    }).catch((err) => {

                        console.log(err.response)

                    })

                break


            }

        }
        


    }


    useEffect(() => {

        setGrupoResiduo_id('')

    }, [residuo_id])


    useEffect(() => {

        if (grupoResiduo_id != null && grupoResiduo_id != '') {

            carregaRelatorio()

        }

    }, [grupoResiduo_id, residuo_id])


    return (

        <div>

            <div className='row'>

                <div className="col-md-12"  >
                    <div class="form-group" >
                        <label className="control-label"><br/>Grupo de resíduos</label>
                        <select class="form-control" value={grupoResiduo_id} onChange={event => setGrupoResiduo_id(event.target.value)} >
                            <option value="">[Selecione]</option>
                            {resultadoGrupoResiduo}
                        </select>
                        
                            
                    </div>
                </div>
                <div className="col-md-12" style={{ display: grupoResiduo_id == 2 ? 'table-row' : 'none' }} >


                    <Table striped bordered hover >

                        <thead>
                            <tr style={{ fontSize: '11px'}}>
                                <th rowSpan={3} style={{ backgroundColor: '#f28e83'}}>
                                    <center>
                                    Ano reportado
                                    </center>
                                </th>
                                
                                <th rowSpan={3} style={{ backgroundColor: '#f28e83'}}>
                                    <center>
                                    Nome do mês
                                    </center>
                                </th>
                                <th colSpan={8} style={{ backgroundColor: '#68bdf2'}}>
                                    <center>
                                    Grupo A [Biológicos]
                                    </center>
                                </th>
                                <th colSpan={2} style={{ backgroundColor: '#68bdf2'}}>
                                    <center>
                                    Grupo A + E [Biológicos + Perfurocortantes]
                                    </center>
                                </th>
                                <th colspan={2} style={{ backgroundColor: '#fcf14c'}}>
                                    <center>
                                    Grupo E [Perfurocortantes]
                                    </center>
                                </th>
                                
                            </tr>
                            <tr  style={{ fontSize: '11px'}}>
                                <th colspan={2} style={{ backgroundColor: '#d2f6fc'}}>
                                    <center>
                                    Subgrupo A3
                                    </center>
                                </th>
                                
                                <th colspan={2} style={{ backgroundColor: '#d2f6fc'}}>
                                    <center>
                                    Subgrupo A4
                                    </center>
                                </th>
                                <th colSpan={2} style={{ backgroundColor: '#d2f6fc'}}>
                                    <center>
                                    Subgrupo A5
                                    </center>
                                </th>
                                <th colSpan={2} style={{ backgroundColor: '#d2f6fc'}}>
                                    <center>
                                    Subgrupo [A1+A4+A5]
                                    </center>
                                </th>

                                <th colSpan={2} style={{ backgroundColor: '#d2f6fc'}}>
                                    <center>
                                    Subgrupo [A1+A4+A5] + Grupo E [Perfurocortantes]
                                    </center>
                                </th>
                                <th colSpan={2} style={{ backgroundColor: '#f0efdf'}}>
                                    <center>
                                    Perfurocortantes
                                    </center>
                                </th>
                                
                            </tr>
                            <tr style={{ fontSize: '11px'}}>
                            
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                            </tr>
                        </thead>

                        <tbody>
                            {resultado}
                        </tbody>

                    </Table>



                </div>

                <div className="col-md-12" style={{ display: grupoResiduo_id == 3 ? 'table-row' : 'none' }} >


                    <Table striped bordered hover >

                        <thead>
                            <tr style={{ fontSize: '11px'}}>
                                <th rowSpan={3} style={{ backgroundColor: '#f28e83'}}>
                                    <center>
                                    Ano reportado
                                    </center>
                                </th>
                                
                                <th rowSpan={3} style={{ backgroundColor: '#f28e83'}}>
                                    <center>
                                    Nome do mês
                                    </center>
                                </th>
                                <th colSpan={8} style={{ backgroundColor: '#dbb353'}}>
                                    <center>
                                    Grupo B [Químicos]
                                    </center>
                                </th>
                                
                                
                            </tr>
                            <tr  style={{ fontSize: '11px'}}>
                                <th colspan={2} style={{ backgroundColor: '#e0d5ba'}}>
                                    <center>
                                    Farmacêutico
                                    </center>
                                </th>
                                
                                <th colspan={2} style={{ backgroundColor: '#e0d5ba'}}>
                                    <center>
                                    Metais Tóxicos
                                    </center>
                                </th>
                                
                                <th colSpan={2} style={{ backgroundColor: '#e0d5ba'}}>
                                    <center>
                                    Químicos perigosos
                                    </center>
                                </th>

                                <th colSpan={2} style={{ backgroundColor: '#e0d5ba'}}>
                                    <center>
                                    Químicos perigosos + Farmacêuticos
                                    </center>
                                </th>
                                
                            </tr>
                            <tr style={{ fontSize: '11px'}}>
                            
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>


                            </tr>
                        </thead>

                        <tbody>
                            {resultado}
                        </tbody>

                    </Table>



                </div>
                <div className="col-md-12" style={{ display: grupoResiduo_id == 4 ? 'table-row' : 'none' }} >


                    <Table striped bordered hover >

                        <thead>
                            <tr style={{ fontSize: '11px'}}>
                                <th rowSpan={3} style={{ backgroundColor: '#f28e83'}}>
                                    <center>
                                    Ano reportado
                                    </center>
                                </th>
                                
                                <th rowSpan={3} style={{ backgroundColor: '#f28e83'}}>
                                    <center>
                                    Nome do mês
                                    </center>
                                </th>
                                <th colSpan={8} style={{ backgroundColor: '#000', color: '#FFF'}}>
                                    <center>
                                    Grupo D [Comum]
                                    </center>
                                </th>
                                
                                
                            </tr>
                            <tr  style={{ fontSize: '11px'}}>
                                <th colspan={2} style={{ backgroundColor: '#89e0c8'}}>
                                    <center>
                                    Recicláveis secos [não orgânicos]
                                    </center>
                                </th>
                                
                                <th colspan={2} style={{ backgroundColor: '#d6c9a7'}}>
                                    <center>
                                    Recicláveis úmidos [orgânicos]
                                    </center>
                                </th>
                                
                                <th colSpan={2} style={{ backgroundColor: '#4d493f', color: '#FFF'}}>
                                    <center>
                                    Rejeito/Indiferenciado
                                    </center>
                                </th>

                                
                            </tr>
                            <tr style={{ fontSize: '11px'}}>
                            
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>


                            </tr>
                        </thead>

                        <tbody>
                            {resultado}
                        </tbody>

                    </Table>



                </div>


                <div className="col-md-12" style={{ display: grupoResiduo_id == 6 ? 'table-row' : 'none' }} >


                    <Table striped bordered hover >

                        <thead>
                            <tr style={{ fontSize: '11px'}}>
                                <th rowSpan={3} style={{ backgroundColor: '#f28e83'}}>
                                    <center>
                                    Ano reportado
                                    </center>
                                </th>
                                
                                <th rowSpan={3} style={{ backgroundColor: '#f28e83'}}>
                                    <center>
                                    Nome do mês
                                    </center>
                                </th>
                                <th colSpan={12} style={{ backgroundColor: '#455c4b', color: '#FFF'}}>
                                    <center>
                                    Grupo Específicos
                                    </center>
                                </th>
                                
                                
                            </tr>
                            <tr  style={{ fontSize: '11px'}}>
                                <th colspan={2} style={{ backgroundColor: '#8ebf9a'}}>
                                    <center>
                                    Eletroeletrônico
                                    </center>
                                </th>
                                
                                <th colspan={2} style={{ backgroundColor: '#8ebf9a'}}>
                                    <center>
                                    Explantes cirúrgicos
                                    </center>
                                </th>

                                <th colspan={2} style={{ backgroundColor: '#8ebf9a'}}>
                                    <center>
                                    Lâmpadas fluorescentes
                                    </center>
                                </th>

                                <th colspan={2} style={{ backgroundColor: '#8ebf9a'}}>
                                    <center>
                                    Óleo combustível
                                    </center>
                                </th>

                                <th colspan={2} style={{ backgroundColor: '#8ebf9a'}}>
                                    <center>
                                    Películas de raio X
                                    </center>
                                </th>

                                <th colspan={2} style={{ backgroundColor: '#8ebf9a'}}>
                                    <center>
                                    Pilhas e baterias
                                    </center>
                                </th>
                                
                                

                                
                            </tr>
                            <tr style={{ fontSize: '11px'}}>
                            
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>

                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#ccccc8'}}>
                                    <center>
                                    [Total de resíduos kg/mês]
                                    </center>
                                </th>


                            </tr>
                        </thead>

                        <tbody>
                            {resultado}
                        </tbody>

                    </Table>



                </div>

            </div>

        </div>

    )

}

export default Residuos_DadosGeracaoConsolidado